import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "multiple-regions"
    }}>{`Multiple Regions`}</h1>
    <p>{`Actions are executed in one of three regions on AWS:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`US East`}</inlineCode>{` (us-east-1) | Northern Virginia`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`EU`}</inlineCode>{` (eu-west-1) | Ireland`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Asia Pacific`}</inlineCode>{` (ap-northeast-1) | Tokyo`}</li>
    </ul>
    <h2 {...{
      "id": "how-do-we-execute-your-action"
    }}>{`How do we execute your action?`}</h2>
    <p>{`Action code is made available in all regions when an action is deployed. At execution time, a latency-based routing policy is used in order to run the action on the fastest available region.`}</p>
    <p>{`In the event a region is unavailable, action invocations will be routed based on latency to one of the available regions.`}</p>
    <p>{`No action is required by the client in order to execute an action on the fastest available region, and the client cannot restrict in which region an action is invoked. `}</p>
    <h2 {...{
      "id": "how-do-i-know-in-what-region-my-actions-are-executed"
    }}>{`How do I know in what region my actions are executed?`}</h2>
    <p>{`The cloud and region in which an action is invoked is available at execution time via environment variables; `}<inlineCode parentName="p">{`__OW_CLOUD`}</inlineCode>{` for the cloud, and `}<inlineCode parentName="p">{`__OW_REGION`}</inlineCode>{` for the region as seen here:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`process.env['__OW_CLOUD'] // example output: aws
process.env['__OW_REGION'] // example output: us-east-1
`}</code></pre>
    <p>{`Please note, that regions can change as part of a failover or due to a permanent platform change. Your application should not work against a hard-coded set of regions and should handle the case when the region you are looking for is not the region where your action is being executed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      